import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sector",
  "use": "icon-sector-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sector\"><path d=\"M160 608c-19.2 0-32 12.8-32 32v128c0 19.2 12.8 32 32 32h64c19.2 0 32-12.8 32-32v-128c0-19.2-12.8-32-32-32h-64z m0-64h64c54.4 0 96 41.6 96 96v128c0 54.4-41.6 96-96 96h-64c-54.4 0-96-41.6-96-96v-128c0-54.4 41.6-96 96-96z m320-320c-19.2 0-32 12.8-32 32v512c0 19.2 12.8 32 32 32h64c19.2 0 32-12.8 32-32v-512c0-19.2-12.8-32-32-32h-64z m0-64h64c54.4 0 96 41.6 96 96v512c0 54.4-41.6 96-96 96h-64c-54.4 0-96-41.6-96-96v-512c0-54.4 41.6-96 96-96z m320 320c-19.2 0-32 12.8-32 32v256c0 19.2 12.8 32 32 32h64c19.2 0 32-12.8 32-32v-256c0-19.2-12.8-32-32-32h-64z m0-64h64c54.4 0 96 41.6 96 96v256c0 54.4-41.6 96-96 96h-64c-54.4 0-96-41.6-96-96v-256c0-54.4 41.6-96 96-96z\" p-id=\"24236\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sector.svg
// module id = NxYr
// module chunks = 12